import * as React from "react";
import System from "src/helper/system";
import avnetAbacus from "src/assets/images/avnet-abacus-logo.png";
import ebvLogo from "src/assets/images/ebv-log.png";
import silicaLogo from "src/assets/images/avnet-silica-logo.png";
const speedBoatFlag = System.auth("speedBoat") === "T" ? avnetAbacus : System.auth("speedBoat") === "B" ? ebvLogo : silicaLogo;
const userAccount = System.auth("account");

export function QuoteCartHeader() {
    return (
        <div className="bg-white mb-0 py-3">
            <div className="container">
                <div className="bs5 d-flex align-items-center justify-content-between">
                    <span>
                        <a href={System.getHomepageUrl()}>
                            <img src={speedBoatFlag} />
                        </a>
                    </span>
                    <span className="bs5 text-end text-black-stone">
                        <p className="mb-0">{userAccount.accountName}</p>
                        <b>
                            {userAccount.accountNumber} -{" "}
                            {userAccount.speedboatDescription}
                        </b>
                    </span>
                </div>
            </div>
        </div>
    );
}
